import { render, staticRenderFns } from "./GiftcardReassurance.vue?vue&type=template&id=5a917eca&scoped=true&"
import script from "./GiftcardReassurance.vue?vue&type=script&lang=js&"
export * from "./GiftcardReassurance.vue?vue&type=script&lang=js&"
import style0 from "./GiftcardReassurance.vue?vue&type=style&index=0&id=5a917eca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a917eca",
  null
  
)

export default component.exports